<app-bread-crumbs [breadcrumbs]="breadcrumbs"></app-bread-crumbs>

<div class="blog-standard-page pt-110 mb-110">
  <div class="container">
    <div class="row gy-5 mb-70">
      <div class="col-lg-8">
        @if (!isLoading) {
          <div class="row gy-5 mb-60">
            @for (blogItem of blogs; track blogItem; let i = $index) {
              <div
                class="col-lg-12 wow animate fadeInDown"
                attr.data-wow-delay="{{ i * 200 }}ms"
                data-wow-duration="1500ms"
                >
                <div
                  class="blog-card"
                  [routerLink]="['/blog-details', blogItem?.slug]"
                  >
                  <div class="blog-card-img-wrap">
                    <a
                      [routerLink]="['/blog-details', blogItem?.slug]"
                      class="card-img"
                      >
                      <img [src]="blogItem?.featured_media" alt="" />
                    </a>
                    <div class="batch">
                      <a
                        [routerLink]="['/blog-details', blogItem?.slug]"
                        class="date"
                        >
                        {{ blogItem?.date | localDateTime : "shortDate" }}
                      </a>
                    </div>
                  </div>
                  <div class="card-content">
                    <h4>
                      <a [routerLink]="['/blog-details', blogItem?.slug]">{{
                        blogItem?.title
                      }}</a>
                    </h4>
                    <p [innerHTML]="blogItem?.excerpt"></p>
                    <a
                      class="view-button"
                      [routerLink]="['/blog-details', blogItem?.slug]"
                      data-translation-key="buyer_homepage_read_more"
                      data-translation-key="buyer_homepage_read_more"
                      >
                      {{ 'buyer_homepage.read_more' | translate }}
                      <svg viewBox="0 0 13 20">
                        <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (paginationData?.totalPages > 1 && !isLoading) {
          <div class="row">
            <div
              class="col-lg-12 d-flex justify-content-center wow animate fadeInUp"
              data-wow-delay="400ms"
              data-wow-duration="1500ms"
              >
              <app-pagination
                [currentPage]="page || 1"
                [totalPages]="paginationData?.totalPages"
                (pageChanged)="onPageChange($event)"
                [isCardPagination]="true"
              ></app-pagination>
            </div>
          </div>
        }
        @if (isLoading) {
          <div class="row wow animate fadeInDown">
            @for (item of [1, 2, 3]; track item) {
              <app-skeleton-loader
                class="blog-card"
                type="auction-card"
              ></app-skeleton-loader>
            }
          </div>
        }
      </div>
      <div class="col-lg-4">
        @if (!isLoading) {
          <div class="sidebar-area">
            <div class="single-widget mb-30">
              <h5
                class="widget-title"
                data-translation-key="buyer_homepage_global_search"
                >
                {{ 'buyer_homepage.global_search' | translate }}
              </h5>
              <form (ngSubmit)="onSearch()">
                <div class="search-box">
                  <input
                    type="text"
                    name="search"
                    [(ngModel)]="searchTerm"
                    [placeholder]="'blogs.buyer_homepage_global_search' | translate"
                    data-translation-key="buyer_homepage_global_search"
                    />
                    <button type="submit"><i class="bx bx-search"></i></button>
                  </div>
                </form>
              </div>
              <div class="single-widget mb-30">
                <h5
                  class="widget-title"
                  data-translation-key="buyer_homepage_popular_post"
                  >
                  {{ 'buyer_homepage.popular_post' | translate }}
                </h5>
                @for (popBlogItem of popularBlogs; track popBlogItem) {
                  <div
                    class="recent-post-widget mb-20"
                    >
                    <div class="recent-post-img">
                      <a [routerLink]="['/blog-details', popBlogItem?.slug]"
                        ><img [src]="popBlogItem?.featured_media" alt=""
                      /></a>
                    </div>
                    <div class="recent-post-content">
                      <a>{{ popBlogItem?.date | localDateTime : "shortDate" }}</a>
                      <h6>
                        <a [routerLink]="['/blog-details', popBlogItem?.slug]">{{
                          popBlogItem?.title
                        }}</a>
                      </h6>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (isLoading) {
            <div class="sidebar-area">
              @for (item of [1]; track item) {
                <app-skeleton-loader
                  class="single-widget"
                  type="auction-card"
                ></app-skeleton-loader>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
